/*
 * @author: sanbao
 * @Date: 2025-12-15 16:29:54
 */

import colorListJson from '../../data/color-list.json'

export const COLOR_VAR_KEYS = [
    '--global-loading-bg',
    '--game-embed-bg',
    '--btn-acrive-color',
    '--btn-color',
    '--apppage-bg1',
    '--apppage-bg2',
    '--appsize-color1',
    '--appsize-color2',
    '--appborder-color',
    '--appleft-btn-bg',
    '--app-top-bg',
    '--app-headerfooter-bg',
    '--app-index-bg',
    '--app-tabbar-bg',
    '--appmail-color',
    '--applogin-tip-color',
    '--applogin-checkbox-color',
]

/** 从 src/data/color-list.json 加载的默认数据 */
export const DEFAULT_COLOR_LIST = colorListJson

/** @deprecated 请使用 getColorList() */
export const ColorList = DEFAULT_COLOR_LIST

export function createEmptyTheme(name = '') {
    const content = {}
    COLOR_VAR_KEYS.forEach((key) => {
        content[key] = '#000000'
    })
    return { name, content }
}

/** 新增色调默认模板名称 */
export const DEFAULT_NEW_THEME_NAME = '桃红色'

/** 按名称取色调模板（用于新增时预填） */
export function createThemeFromTemplate(templateName = DEFAULT_NEW_THEME_NAME, name = '') {
    const found = DEFAULT_COLOR_LIST.find((item) => item && item.name === templateName)
    if (found && found.content) {
        return normalizeColorList([{ name, content: { ...found.content } }])[0]
    }
    return createEmptyTheme(name)
}

/** 新增色调默认使用桃红色 */
export function createDefaultNewTheme(name = '') {
    return createThemeFromTemplate(DEFAULT_NEW_THEME_NAME, name)
}

/** 规范化主题数据，补全缺失的 CSS 变量 */
export function normalizeColorList(list) {
    if (!Array.isArray(list)) return []
    return list.map((item) => {
        const content = {}
        COLOR_VAR_KEYS.forEach((key) => {
            content[key] =
                (item && item.content && item.content[key]) || '#000000'
        })
        return {
            name: (item && item.name) || '未命名',
            content,
        }
    })
}

/** 同步读取打包内的 color-list.json（构建时快照） */
export function getColorList() {
    return normalizeColorList(DEFAULT_COLOR_LIST)
}

/**
 * 从服务端读取最新的 color-list.json（开发环境走 devServer API）
 */
export async function fetchColorList() {
    if (process.env.NODE_ENV === 'development') {
        try {
            const res = await fetch(`/api/color-list?_=${Date.now()}`)
            if (res.ok) {
                const data = await res.json()
                if (Array.isArray(data) && data.length) {
                    return normalizeColorList(data)
                }
            }
        } catch (e) {
            console.warn('[zhutiColor] 读取 color-list.json 失败，使用打包数据:', e)
        }
    }
    return getColorList()
}

/**
 * 写入 src/data/color-list.json（仅开发环境 devServer 支持）
 * @returns {{ normalized: Array, jsonSynced: boolean }}
 */
export async function saveColorList(list) {
    const normalized = normalizeColorList(list)

    let jsonSynced = false
    if (process.env.NODE_ENV === 'development') {
        try {
            const res = await fetch('/api/save-color-list', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(normalized),
            })
            jsonSynced = res.ok
        } catch (e) {
            console.warn('[zhutiColor] 写入 color-list.json 失败:', e)
        }
    }
    return { normalized, jsonSynced }
}

export function resetColorList() {
    return getColorList()
}

/** 解析粘贴的 CSS 变量代码，如 '--apppage-bg1': '#d35577', */
export function parseColorPaste(text) {
    const result = {}
    if (!text || !text.trim()) return result
    const re = /['"]?(--[\w-]+)['"]?\s*:\s*['"]?(#[0-9a-fA-F]{3,8}|rgba?\([^)]+\))['"]?/gi
    let m
    while ((m = re.exec(text)) !== null) {
        result[m[1]] = m[2]
    }
    return result
}

/** 格式化为可粘贴的代码片段 */
export function formatColorsForPaste(colors) {
    return COLOR_VAR_KEYS.map(
        (key) => `            '${key}': '${colors[key] || ''}',`
    ).join('\n')
}

export function exportColorListJs(list) {
    const body = list
        .map((item) => {
            const lines = COLOR_VAR_KEYS.map(
                (key) => `            '${key}': '${item.content[key] || ''}',`
            )
            return `    {\n        name: "${item.name}",\n        content: {\n${lines.join('\n')}\n        }\n    }`
        })
        .join(',\n')
    return `export const ColorList = [\n${body},\n]`
}
